import { addMonths, endOfMonth, format, parse, startOfMonth } from "date-fns";
import { ptBR } from "date-fns/locale";
import { currentWorkDate, dateToDateOnly } from "@/lib/format";

const MONTH_KEY = /^\d{4}-\d{2}$/;

const numberFormatter = new Intl.NumberFormat("pt-BR");
const percentFormatter = new Intl.NumberFormat("pt-BR", {
	maximumFractionDigits: 2,
});

export function formatHoursMinutes(minutes: number): string {
	const total = Math.round(Math.abs(minutes));
	const hours = Math.floor(total / 60);
	const rest = total % 60;
	const sign = minutes < 0 ? "-" : "";
	return `${sign}${String(hours).padStart(2, "0")}:${String(rest).padStart(2, "0")}`;
}

export function formatPct(value: number): string {
	return `${percentFormatter.format(value)}%`;
}

export function formatCount(value: number): string {
	return numberFormatter.format(value);
}

export function currentMonth(): string {
	return currentWorkDate().slice(0, 7);
}

export function monthToDate(month: string): Date | undefined {
	if (!MONTH_KEY.test(month)) return undefined;
	const parsed = parse(month, "yyyy-MM", new Date());
	return Number.isNaN(parsed.getTime()) ? undefined : startOfMonth(parsed);
}

export function shiftMonth(month: string, amount: number): string {
	const date = monthToDate(month);
	if (!date) return month;
	return format(addMonths(date, amount), "yyyy-MM");
}

export function monthLabel(month: string): string {
	const date = monthToDate(month);
	if (!date) return month;
	const label = format(date, "MMMM 'de' yyyy", { locale: ptBR });
	return label.charAt(0).toUpperCase() + label.slice(1);
}

export function monthRange(month: string): { from: string; to: string } {
	const date = monthToDate(month);
	if (!date) return { from: "", to: "" };
	return { from: dateToDateOnly(date), to: dateToDateOnly(endOfMonth(date)) };
}

export function isMonthAfter(month: string, reference: string): boolean {
	return month > reference;
}

export function dayNumberLabel(date: string): string {
	return date.slice(8, 10);
}

export function weekdayShortLabel(date: string): string {
	const parsed = parse(date, "yyyy-MM-dd", new Date());
	if (Number.isNaN(parsed.getTime())) return "";
	return format(parsed, "EEEEEE", { locale: ptBR });
}
